import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { fundraisingService } from '../../services/fundraisingService';

export const useCheckApplicationStatusById = applicationId => {
  const queryClient = useQueryClient();
  return useQuery({
    refetchInterval: data => {
      if (!data) return false; // stop polling if no data
      if (data.state.data?.status === FR_APPLICATION_STATUSES.PRE_CHECKS) {
        return 5000; // start polling
      }
      return false;
    },
    queryKey: [QUERY_KEYS.fundraising.application_status_by_id, applicationId],
    queryFn: () =>
      fundraisingService.applicationStatusById(applicationId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          data?.status !== FR_APPLICATION_STATUSES.PRE_CHECKS &&
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.application_by_fundraising_id] });
          return data;
        }
        throw new Error('Error fetching founder application');
      }),
  });
};
